import React from 'react';
import Chip from '@mui/material/Chip';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { CurrencyText } from '../input-formatters/CurrencyText';
import StatusChip from '../StatusChip';

const AgGridCurrencyChipCell = ({ value, useCompactViewStyle = false }: ICellRendererParams & { useCompactViewStyle?: boolean }) => {
  const displayAmount = parseFloat(value?.toFixed(2));
  if (value === null || value === undefined) {
    return <CurrencyText value={displayAmount} />;
  }

  return (
    <>
      {useCompactViewStyle ? (
        <StatusChip
          color={displayAmount >= 0 ? 'success' : 'error'}
          label={<CurrencyText value={displayAmount} />}
          size="small"
          variant="light"
        />
      ) : (
        <Chip
          color={displayAmount >= 0 ? 'success' : 'error'}
          label={<CurrencyText value={displayAmount} />}
          size="small"
          variant="light"
        />
      )}
    </>
  );
};

export default AgGridCurrencyChipCell;
